
import { Http } from '@/lib/utils/Http'
import { Component, Vue } from 'vue-property-decorator'

import BacModal from '@/components/BacModal.vue'
import UIkit from 'uikit'

@Component({
  components: {
    BacModal
  }
})
export default class TeamareaStatTable extends Vue {
  stats: any[] = [];
  currentStat: any = {}
  mounted () {
    this.loadStats()
  }

  async loadStats () {
    const response = await Http.request(
      '/api/statistics/most-orders-customers'
    )
    const data = await response.json()

    this.stats = data
  }

  openRodeoStatModal (stat: any) {
    this.currentStat = stat
    UIkit.modal('#rodeo-stat-modal').show()
  }
}
